import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseInvoiceBranchURL = `api/v1/purchase-app/purchase-invoice/branch`;

//obtaining the paginated data
export const getPurchaseInvoiceBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseInvoiceBranchURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseInvoiceBranch = () => axiosInstance.get(`${purchaseInvoiceBranchURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseInvoiceBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseInvoiceBranchURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );
// get by id
export const getPurchaseInvoiceBranchById = (id) => axiosInstance.get(`${purchaseInvoiceBranchURL}/retrieve/${id}`);

//get purchase detail from grn
export const getPurchaseOrderDetail = (id) => axiosInstance.get(`api/v1/purchase-app/grn/retrieve/${id}`);

//creating function
export const createPurchaseInvoiceBranch = (body) => axiosInstance.post(`${purchaseInvoiceBranchURL}/create`, body);
//updating function
export const updatePurchaseInvoiceBranch = (id, body) =>
  axiosInstance.patch(`${purchaseInvoiceBranchURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseInvoiceBranchURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
